import { render } from "./ChangeCategory.vue?vue&type=template&id=653df1e4&scoped=true"
import script from "./ChangeCategory.js?vue&type=script&lang=js"
export * from "./ChangeCategory.js?vue&type=script&lang=js"

import "./ChangeCategory.vue?vue&type=style&index=0&id=653df1e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653df1e4"]])

export default __exports__